/*
Icons used in the critical rendering path, they include:
- Club
- User_menu
- Cart_nav
- Menu
- Checkmark_old
- Wishlist
- Search
- Close
- Upload
  Those can be removed during the next refactoring (header needs to be modified to use full RWD for caching purposes). 
- Close_border
- Chevron_right
- Chevron_down
*/

export const CriticalIconsSprite = () => {
  return (
    <div style={{ display: 'none' }}>
      <svg
        height="0"
        style={{ position: 'absolute' }}
        width="0"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <symbol fill="none" id="icon_Upload" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M7 12C7.27614 12 7.5 11.7761 7.5 11.5C7.5 11.2239 7.27614 11 7 11V12ZM5 11.5V11C4.72386 11 4.5 11.2239 4.5 11.5H5ZM5 19.5H4.5C4.5 19.7761 4.72386 20 5 20V19.5ZM19 19.5V20C19.2761 20 19.5 19.7761 19.5 19.5H19ZM19 11.5H19.5C19.5 11.2239 19.2761 11 19 11V11.5ZM17 11C16.7239 11 16.5 11.2239 16.5 11.5C16.5 11.7761 16.7239 12 17 12V11ZM11.5 14.5C11.5 14.7761 11.7239 15 12 15C12.2761 15 12.5 14.7761 12.5 14.5H11.5ZM12 4L12.3536 3.64645C12.1583 3.45118 11.8417 3.45118 11.6464 3.64645L12 4ZM15.1464 7.85355C15.3417 8.04882 15.6583 8.04882 15.8536 7.85355C16.0488 7.65829 16.0488 7.34171 15.8536 7.14645L15.1464 7.85355ZM8.14645 7.14645C7.95118 7.34171 7.95118 7.65829 8.14645 7.85355C8.34171 8.04882 8.65829 8.04882 8.85355 7.85355L8.14645 7.14645ZM7 11H5V12H7V11ZM4.5 11.5V19.5H5.5V11.5H4.5ZM5 20H19V19H5V20ZM19.5 19.5V11.5H18.5V19.5H19.5ZM19 11H17V12H19V11ZM12.5 14.5V4H11.5V14.5H12.5ZM11.6464 4.35355L15.1464 7.85355L15.8536 7.14645L12.3536 3.64645L11.6464 4.35355ZM11.6464 3.64645L8.14645 7.14645L8.85355 7.85355L12.3536 4.35355L11.6464 3.64645Z"
            fill="#10111A"
          ></path>
        </symbol>
        <symbol fill="none" id="icon_Club" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M20.874 6.384a.5.5 0 10-.845.536l.845-.536zM5.927 19.306a.5.5 0 10-.64.768l.64-.768zm12.22-14.55a.5.5 0 00.648-.761l-.648.762zM1.947 15.04a.5.5 0 00.957-.29l-.957.29zm18.082-8.12A9.453 9.453 0 0121.5 12h1c0-2.064-.596-3.991-1.626-5.616l-.845.536zM21.5 12a9.5 9.5 0 01-9.5 9.5v1c5.799 0 10.5-4.7 10.5-10.5h-1zM12 21.5a9.46 9.46 0 01-6.073-2.194l-.64.768A10.46 10.46 0 0012 22.5v-1zm6.795-17.505A10.46 10.46 0 0012 1.5v1a9.46 9.46 0 016.147 2.257l.648-.762zM12 1.5C6.201 1.5 1.5 6.201 1.5 12h1A9.5 9.5 0 0112 2.5v-1zM1.5 12c0 1.056.156 2.076.447 3.039l.957-.29A9.5 9.5 0 012.5 12h-1z"
            fill="#10111A"
          ></path>
          <path
            d="M16.706 13.864l-1.504.783.295-1.67-1.209-1.187 1.678-.238.756-1.516.744 1.523 1.676.251-1.219 1.178.28 1.672-1.497-.796z"
            fill="#1185ED"
          ></path>
          <path
            d="M15.343 15.092c-1.09 1.34-2.302 2.04-3.58 2.04l-.074-.001c-1.505-.031-2.206-.685-2.586-2.413-.349-1.585.195-3.683.219-3.772.009-.038.255-1.03.499-1.588.687-1.576 1.918-2.765 2.863-2.765.064 0 .127.006.186.017.387.073.695.307.891.677.27.509.304 1.232.11 1.94.544-.19 1.155-.557 1.566-1.079.464-.59.475-1.46.027-2.115-.304-.447-.666-.783-1.076-1a5.876 5.876 0 00-1.579-.557 3.906 3.906 0 00-.815-.089c-.943 0-1.825.369-2.628 1.096l-.193.185c-1.688 1.445-3.01 4.886-3.01 7.833 0 .211.01.435.03.664.001.012.094 1.079.536 2.103.771 1.787 2.127 2.693 4.03 2.693 1.677 0 4.033-.838 6.076-4.621l-1.492.752z"
            fill="#10111A"
          ></path>
        </symbol>
        <symbol id="icon_User_menu" viewBox="0 0 19.608 19.943" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M7.962 19.792h-7.2a.614.614 0 01-.614-.614 9.317 9.317 0 016.928-8.8 5.527 5.527 0 01-2.632-4.7A5.532 5.532 0 019.971.15a5.531 5.531 0 015.525 5.524 5.527 5.527 0 01-2.743 4.772 9.3 9.3 0 016.705 8.732.613.613 0 01-.613.614zm10.243-1.228a8.36 8.36 0 00-8.4-7.365 8.361 8.361 0 00-8.4 7.365h16.8zM5.674 5.673a4.3 4.3 0 004.3 4.3 4.3 4.3 0 004.3-4.3 4.3 4.3 0 00-4.3-4.3 4.3 4.3 0 00-4.3 4.301z"
            stroke="#fff"
            strokeWidth="0.3"
          ></path>
        </symbol>
        <symbol
          fill="none"
          id="icon_Cart_nav"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.826 7.368H1s.07.073 1.353 7.632h13.513l3.093-12H23"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <circle cx="5" cy="20" r="2" stroke="currentColor"></circle>
          <circle cx="12" cy="20" r="2" stroke="currentColor"></circle>
        </symbol>
        <symbol fill="none" id="icon_Menu" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M2 6h20M2 12h20M2 18h20" stroke="currentColor" strokeLinecap="round"></path>
        </symbol>
        <symbol
          id="icon_Checkmark_old"
          viewBox="0 0 25.2 25.207"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g
            data-name="Group 11889"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="1.2"
          >
            <path
              d="M4.115 21.085a11.984 11.984 0 112.309 1.807"
              data-name="Path 13539"
              stroke="#000"
            ></path>
            <path
              d="M5.6 12.681l5.205 4.8a.443.443 0 00.632-.039L19.6 7.6"
              data-name="Path 13540"
              stroke="#0084f5"
            ></path>
          </g>
        </symbol>
        <symbol
          fill="none"
          id="icon_Wishlist"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.858 6.194a.5.5 0 00.956 0c.581-1.909 2.447-2.868 4.313-2.668 1.836.196 3.635 1.522 3.997 4.212.362 2.694-1.296 5.536-3.437 7.949-1.95 2.197-4.206 3.932-5.35 4.712-1.146-.78-3.399-2.514-5.347-4.712-2.14-2.413-3.798-5.255-3.441-7.95.356-2.69 2.154-4.015 3.991-4.211 1.869-.2 3.737.76 4.318 2.668z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
        </symbol>
        <symbol fill="none" id="icon_Search" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path
            clipRule="evenodd"
            d="M10 2.5a7.5 7.5 0 100 15 7.5 7.5 0 000-15zM1.5 10a8.5 8.5 0 1114.997 5.48l4.666 4.666a.5.5 0 01-.707.708l-4.648-4.648A8.5 8.5 0 011.5 10z"
            fill="currentColor"
            fillRule="evenodd"
          ></path>
        </symbol>
        <symbol fill="none" id="icon_Close" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M6 6c0-.091 12 11.908 12 11.908M6 18L18 6"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
        </symbol>
        <symbol
          fill="none"
          id="icon_Close_border"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.705 19.965a.5.5 0 00.721-.692l-.721.692zm-2.703-7.77l.5-.009-.5.01zM3.8 4.667l.373.334-.373-.334zm7.17-3.619l-.047-.497.047.497zm7.718 2.219l.305-.397-.305.397zm4.154 6.874l-.493.084.493-.084zm-1.626 7.865l.419.273-.42-.273zm-6.539 4.663l.122.485-.121-.485zm-7.725-1.462a.5.5 0 00-.48.877l.48-.877zm-2.526-1.934a10.5 10.5 0 01-2.924-7.087l-1 .018a11.5 11.5 0 003.203 7.761l.721-.692zm-2.924-7.087a10.5 10.5 0 012.671-7.185l-.745-.667a11.5 11.5 0 00-2.926 7.87l1-.018zm2.671-7.185a10.5 10.5 0 016.844-3.455l-.094-.995a11.5 11.5 0 00-7.495 3.783l.745.667zm6.844-3.455a10.5 10.5 0 017.367 2.118l.608-.794A11.5 11.5 0 0010.923.55l.094.996zm7.367 2.118a10.5 10.5 0 013.965 6.561l.986-.169a11.5 11.5 0 00-4.343-7.186l-.608.794zm3.965 6.561a10.5 10.5 0 01-1.552 7.508l.838.546a11.5 11.5 0 001.7-8.223l-.986.17zm-1.552 7.508a10.5 10.5 0 01-6.241 4.451l.243.97a11.5 11.5 0 006.836-4.875l-.838-.546zm-6.241 4.451a10.5 10.5 0 01-7.604-.977l-.48.877a11.5 11.5 0 008.327 1.07l-.243-.97z"
            fill="currentColor"
          ></path>
          <path
            d="M8.568 8.568c0-.054 7.04 6.986 7.04 6.986M8.568 15.608l7.04-7.04"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
        </symbol>
        <symbol
          fill="none"
          id="icon_Chevron_right"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 5l5.885 6.696a.402.402 0 010 .562L9 19"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
        </symbol>
        <symbol
          fill="none"
          id="icon_Chevron_down"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19 9l-6.696 5.885a.402.402 0 01-.562 0L5 9"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
        </symbol>
      </svg>
    </div>
  );
};
